import { useState, useRef, useEffect } from 'react'

// local imports
import { IDoctorFilterForm, IFilteredDoctorList } from 'types/HealthType'
import HealthService from 'service/HealthService'

export default function useGetDoctorList() {
  const [doctors, setDoctors] = useState<IFilteredDoctorList[] | []>([])
  const [loading, setLoading] = useState(false)
  const isMountedRef = useRef(true)

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  /* Get Doctor List */
  const getDoctorList = (data: IDoctorFilterForm) => {
    if (!isMountedRef.current) return
    setLoading(true)
    HealthService.getDoctorFilteredList(data)
      .then((r) => {
        if (isMountedRef.current) {
          setDoctors(r.data)
        }
      })
      .finally(() => {
        if (isMountedRef.current) {
          setLoading(false)
        }
      })
  }

  return { doctors, getDoctorList, loading }
}
